import { Button } from "antd"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"

import { DeclineModal } from "./DeclineModal.tsx"
import { TOUCH } from "./touch.ts"
import type { Outcome } from "./types.ts"
import { ask } from "./use-signing.ts"

interface Props {
  decline(reason: string): Promise<Outcome<unknown>>
  onDeclined(): void
  onOpen?(): void
}

export function DeclineAction({ decline, onDeclined, onOpen }: Props) {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button
        danger
        onClick={() => {
          onOpen?.()
          setOpen(true)
        }}
        style={TOUCH}
      >
        {t("signing.sign.decline")}
      </Button>
      <DeclineModal
        open={open}
        onCancel={() => setOpen(false)}
        onDecline={(reason) => ask(() => decline(reason))}
        onDeclined={() => {
          setOpen(false)
          onDeclined()
        }}
      />
    </>
  )
}
